import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col w-full mtop-10" }
const _hoisted_2 = { class: "col w-full mtop-15" }
const _hoisted_3 = { class: "margin-h3" }
const _hoisted_4 = {
  key: 0,
  class: "row w-full mtop-15"
}
const _hoisted_5 = {
  key: 1,
  class: "col gap-04 w-full"
}
const _hoisted_6 = { class: "w-full mright-04" }
const _hoisted_7 = {
  key: 2,
  class: "row w-full mtop-15"
}

import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { DelegatePermissionResponse, SettingsApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ApiError, ItemSelect } from '@/models/share.model';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import ToggleSwitch from 'primevue/toggleswitch';


export default /*@__PURE__*/_defineComponent({
  __name: 'esPatientManagementDelegateSettings',
  props: {
    selectedInstitute: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const patientSettingsApi = new SettingsApi(medServerApiConfig);
const toast = useToast();

const delegatePermissions = ref<DelegatePermissionResponse[]>([]);
const loadingPermission = ref<boolean>(false);

const getDelegatePermission = async () => {
  if (props.selectedInstitute) {
    loadingPermission.value = true;
    patientSettingsApi.getDelegatePermissionsByInstitute({instituteId: props.selectedInstitute.id}).then((response: DelegatePermissionResponse[]) => {
        delegatePermissions.value = response;
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t('error.' + error.status) : t('common.toast.error')
      });
    }).finally(() => {
      loadingPermission.value = false;
    });
  }
}

const handlePermissionToggle = async (delegatePerm: DelegatePermissionResponse) => {
    if (delegatePerm && delegatePerm.id && props.selectedInstitute) {
      patientSettingsApi.updateDelegatePermissions({instituteId: props.selectedInstitute.id, delegatePermId: delegatePerm.id}).then((response: DelegatePermissionResponse[]) => {
        toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail:  t('settings.label.patient.managementDelegate.update.message.success')
        });
        delegatePermissions.value = response;
      }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t('error.' + error.status) : t('common.toast.error')
        });
      });
    }
}

// refresh on institute selection change
watch(
  ()=> props.selectedInstitute, 
  async  () => {
    await getDelegatePermission();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('settings.label.patient.managementDelegate.title')), 1),
      (loadingPermission.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('settings.label.patient.managementDelegate.loading')), 1))
        : (delegatePermissions.value && delegatePermissions.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delegatePermissions.value, (permission) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row-space-between w-full es-main-settings mtop-10",
                  key: permission.id
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(permission.name), 1),
                  _createVNode(_unref(ToggleSwitch), {
                    modelValue: permission.allowed,
                    "onUpdate:modelValue": ($event: any) => ((permission.allowed) = $event),
                    onChange: () => handlePermissionToggle(permission)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('settings.label.patient.managementDelegate.empty')), 1))
    ])
  ]))
}
}

})